import { cloneDeep } from 'lodash';
import { InteractionStepTaskComponent } from '../../InteractionStep';
import {
  DEFAULT_TEXTCOLLECTION_SUBTITLE,
  DEFAULT_TEXTCOLLECTION_TITLE,
  InteractionStepType,
} from '@scale/shared/types/chat';
import { useStepParams } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';

import { StepWidthWrapper, StepWidth } from '../../step/StepWidthWrapper';
import { StepCard } from '../../step/StepCard';
import { PinButton } from '../../step/PinButton';
import Form from './Form';
import { useContext, useMemo } from 'react';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';

const FormTaskComponent: InteractionStepTaskComponent = ({ responseIndex, isPinnedView }) => {
  const taskContext = useContext(ChatTaskContext);

  const _step = useStepParams<InteractionStepType.TextCollectionPerResponse>(responseIndex);
  const step = useMemo(() => {
    const patchedStep = cloneDeep(_step);
    patchedStep.params.fields = patchedStep.params.fields.map(field => ({
      ...field,
      disable_pasting:
        (taskContext.disablePastingTextCollectionFieldIds ?? []).includes(field.field_id) ||
        taskContext.disablePastingAllTextCollectionFields,
    }));
    return patchedStep;
  }, [
    _step,
    taskContext.disablePastingTextCollectionFieldIds,
    taskContext.disablePastingAllTextCollectionFields,
  ]);

  return (
    <StepWidthWrapper width={isPinnedView ? StepWidth.Full : StepWidth.Responsive}>
      <StepCard>
        <StepCard.Header>
          <StepCard.HeaderLeft>
            <StepCard.Icon icon="question-circle" />
            <StepCard.HeaderColumn>
              <StepCard.Title>{step.title || DEFAULT_TEXTCOLLECTION_TITLE}</StepCard.Title>
              <StepCard.Subtitle>
                {step.subtitle || DEFAULT_TEXTCOLLECTION_SUBTITLE}
              </StepCard.Subtitle>
            </StepCard.HeaderColumn>
          </StepCard.HeaderLeft>
          <StepCard.HeaderRight>
            <PinButton responseIndex={responseIndex} />
          </StepCard.HeaderRight>
        </StepCard.Header>
        <StepCard.Body>
          <Form fields={step.params.fields} readOnly={false} />
          <div>You are using the new Form Task Component!</div>
        </StepCard.Body>

        <StepCard.Footer className="flex justify-end"></StepCard.Footer>
      </StepCard>
    </StepWidthWrapper>
  );
};

export default FormTaskComponent;
